import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { Link } from 'react-router-dom';
import Spinner from '../../../common/Spinner/Spinner';
import formatDateToBR from '../../../utils/formatDateToBR';
import NewsImage from './NewsImage';

const NewsHomeMostReadComponent = ({
    newsMostRead = [],
    fetchDataNewsMostReadIfNeeded = () => {},
    countNewsView = () => {},
}) => {
    useEffect(() => {
        fetchDataNewsMostReadIfNeeded();
    }, [fetchDataNewsMostReadIfNeeded]);

    const homeNewsMostRead = newsMostRead;

    useEffect(() => {
        homeNewsMostRead.forEach((news) => {
            countNewsView({
                newsId: news.newsId,
                timestamp: Date.now(),
            });
        });
    }, [homeNewsMostRead, countNewsView]);

    const renderNews = () => homeNewsMostRead.map((news) => {
        const link = `/noticias/${news.slug}`;

        return (
            <Link
                key={news.newsId}
                to={link}
                className="tw-flex tw-flex-col tw-items-start tw-text-start"
                title={`Read more about ${news.title}`}
            >
                <p className="tw-text-sm tw-mb-0 tw-text-gray-500 data-publicacao">
                    {formatDateToBR(news.date)}
                </p>
                <div className="title-news">
                    <h3 className="tw-text-lg tw-text-start tw-font-bold tw-text-black tw-mb-4 limitText2">
                        {news.title.replace(/<[^>]+>/g, '')}
                    </h3>
                </div>
                <div className="tw-w-full tw-mt-4 tw-overflow-hidden">
                    <NewsImage news={news} sizes="(min-width: 1024px) 25vw, (min-width: 768px) 50vw, calc(100vw - 40px)" />
                </div>
            </Link>
        );
    });

    return (
        <section className="tw-w-full" id="section-mais-lidas-home">
            <div className="tw-container tw-m-auto tw-px-5">
                <header className="tw-mb-6 tw-flex tw-items-center tw-justify-between tw-border-t tw-border-b tw-border-black tw-py-4 tw-px-0">
                    <h2 className="tw-text-sm tw-mb-0 tw-font-semibold tw-text-gray-600">
                        Mais lidas da semana
                    </h2>
                </header>

                <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-4 tw-gap-10">
                    {homeNewsMostRead.length > 0 ? (
                        renderNews()
                    ) : (
                        <div className="tw-flex tw-justify-center tw-items-center">
                            <Spinner />
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

NewsHomeMostReadComponent.propTypes = exact({
    newsMostRead: PropTypes.array.isRequired,
    fetchDataNewsMostReadIfNeeded: PropTypes.func.isRequired,
    countNewsView: PropTypes.func.isRequired,
});

export default NewsHomeMostReadComponent;
